<template>
  <v-dialog 
  :value="value" 
  max-width="1000"
  @input="$emit('input')">
    <v-card class="pb-2">
      <v-card-title style="justify-content:space-between" v-if="isRemark">
        <span class="headline">CC Remarks for @{{handle}}</span>
      </v-card-title>
      <v-card-title style="justify-content:space-between" v-else>
        <span class="headline">Campaign Lists for @{{handle}}</span>
        <span style="color:grey;font-size:12px" v-if="emptyCampaigns">({{emptyCampaigns}}) Campaigns Not Found</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="computedHeaders"
              :items="items"
              :items-per-page="10"
              :no-data-text="'Empty list'"
              class="campaign-lists-table elevation-1"              
              :key="dataTableKey"
            >
              <template v-slot:[`item.pairingDate`]="{ item }">
                <tr>
                  <td class="text-xs-left" style="min-width:100px;">
                    {{item.pairingDate}}
                  </td>
                </tr>
              </template>
              <template v-slot:[`item.isArchive`]="{ item }">
                <tr>
                  <td class="text-xs-left">
                    <span v-if="item.archive">YES</span>
                    <span v-else>NO</span>
                  </td>
                </tr>
              </template>
              <template v-slot:[`item.deliverables`]="{ item }">
                <tr>
                  <td class="text-xs-left">
                    {{campaignHelper.getDeliverableDetails(item.deliverables)}}
                  </td>
                </tr>
              </template>
              <template v-slot:[`item.payout`]="{ item }">
                <tr>
                  <td class="text-xs-left">
                    $ {{item.payout | thousandSeprator}}
                  </td>
                </tr>
              </template>
              <template v-slot:[`item.ccRemarks`]="{ item }">
                <tr>
                  <td class="text-xs-left" style="min-width:200px">
                    <v-tooltip bottom color="black" max-width="300px">
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <p class="remark-text">{{item.ccRemarks || '-'}}</p>
                        </div>
                      </template>
                      <span  v-html="formatDesc(item.ccRemarks)"></span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          @click="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import campaignHelper from '../../Campaign/campaignHelper';
export default {
  name: 'CampaignListsModal',
  props: [
    'items',
    'value',
    'handle',
    'isRemark',
    'emptyCampaigns'
  ],
  data() {
    return {
      headers: [
        {
          text: 'Campaign Name',
          value: 'name'
        },
        {
          text: 'Campaign Type',
          value: 'campaignType'
        },
        {
          text: 'Campaign Verticals',
          value: 'showVerticals'
        },
        {
          text: 'Stage',
          value: 'campaignStatusDisplay'
        },
        {
          text: 'Deliverables',
          value: 'deliverables'
        },
        {
          text: 'Payout Amount',
          value: 'payout'
        },
        {
          text: 'Pairing Date',
          value: 'pairingDate'
        },
        {
          text: 'CC Remarks',
          value: 'ccRemarks'
        },
        {
          text: 'Archive Status',
          value: 'isArchive'
        }
      ],
      dataTableKey: 1,
      campaignHelper
    }
  },
  computed: {
    computedHeaders() {
      let exceptHeaders = [
        'campaignType',
        'showVerticals',
        'campaignStatusDisplay',
        'deliverables',
        'payout',
        'pairingDate',
        'isArchive'
      ]
      if (this.isRemark) {
        return this.headers.filter(h => !exceptHeaders.includes(h.value))
      }
      return this.headers
    }
  },
  methods: {
    formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>')
      }
      return text
    },
    close() {
      this.$emit('input')
    }
  }
}
</script>
<style>
  .campaign-lists-table .remark-text {
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// CampaignListsModal.vue?0df2194e